import { useEffect } from "react";
import { useChatContext } from "..";
import { useActor, useSelector } from "@xstate/react";
import { IChatMachineBoxContext } from "../machine";
import { Livechat } from "@api";
import { EMessageType, IInCommingMessage, IMessageAction } from "@types";
import { useAppStore } from "@store/appStore";
import { shallow } from "zustand/shallow";
import { generateActionMessage } from "@fns";

const selectMessage = ({ context }: { context: IChatMachineBoxContext }) =>
  context.messages;
const selectFirstItemIndex = ({
  context,
}: {
  context: IChatMachineBoxContext;
}) => context.firstItemIndex;

export const useMessageBox = () => {
  const machineService = useChatContext();
  const { user, token, room } = useAppStore((state) => {
    return {
      user: state.user,
      token: state.token,
      room: state.room,
    };
  }, shallow);
  const [state] = useActor(machineService.chatService);
  const { send } = machineService.chatService;
  const messages = useSelector(machineService.chatService, selectMessage);
  const firstItemIndex = useSelector(
    machineService.chatService,
    selectFirstItemIndex
  );

  useEffect(() => {
    let ignore = false;
    Livechat.onMessage((message) => {
      const incomming = message as unknown as IInCommingMessage;
      if (!ignore) {
        send("NEW_INCOMING_MESSAGE", {
          payload: {
            uid: user._id,
            newMessage: incomming,
          },
        });
      }
    });
  }, []);

  return {
    firstItemIndex,
    isFirstFetching: state.matches("firstFetchingMessages"),
    isUserSendMessage: state.matches("sendingMessage"),
    isLoadingMore: state.matches("fetchingMoreMessages"),
    messages,
    onSendAction: async (action: IMessageAction) => {
      try {
        const outgoing = await generateActionMessage(action, room, token);
        // if null
        if (!outgoing) return;
        send("SEND_MESSAGE", outgoing);
      } catch (error) {
        console.error("error create message action ", error);
      }
    },
    onLoadMoreMessages: () => {
      send("LOAD_MORE_MESSAGES");
    },
  };
};
